import { AddressField, AddressValues } from "../ProfilePageTypes";

export const AddressValidation = (values: AddressValues) => {
  const fields: AddressField[] = [
    {
      name: "landmark",
      label: "Landmark",
      type: "enter",
    },
    {
      name: "flat_no",
      label: "Door/Flat No",
      type: "enter",
    },
    // {
    //   name: "locality",
    //   label: "Area/Sector/Locality",
    //   type: "enter",
    // },
    // {
    //   name: "type",
    //   label: "Type",
    //   type: "choose",
    // },
  ];

  let errors: Partial<AddressValues> = {};

  fields.forEach((field) => {
    const value = values[field?.name].trim() || "";

    if (!value) {
      errors[field.name] = `Please ${field.type} ${field.label}.`;
    }
  });

  return errors;
};
